// ======================================================================
// File Name       : UserCheckContainer.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Modal, Button } from 'react-bootstrap';
import { registerUpdateUser } from '../../actions/UserAction';
import UserDetail from '../../components/user/UserDetail';
import * as Constant from '../../constants/index';
import { USER_LIST } from '../../constants/PathConstants';

class UserCheckContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: Constant.MODE.NEW_MODE,
      auth: {},
      showCheck: false,
      userDetail: {},
      selectedGroupList: [],
      managementAuthoritys: {
        bySecernId: {},
        allSecernIds: [],
      },
      userAttributes: {},
      showLoginIdPasswordSendFlag: true,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps) {
      const {
        user,
        mode,
        showCheck,
        userDetail,
        selectedGroupList,
        oldSelectedGroupList,
        groupList,
        userAttributes,
        childUserList,
        oldChildUserList,
      } = nextProps;
      const { managementAuthoritys } = user;
      this.setState({
        mode,
        showCheck,
        userDetail,
        groupList,
        selectedGroupList,
        oldSelectedGroupList,
        managementAuthoritys,
        userAttributes,
        childUserList,
        oldChildUserList,
      });
    }
  }


  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    return (
      <Modal
        className="modal-container"
        show={this.state.showCheck}
        onHide={this.props.onCancel}
        size={Constant.MODAL_SIZE.lg}
        style={style}
      >
        <Modal.Header onHide={this.props.onCancel} closeButton>
          <Modal.Title className="text-center">
            以下の内容で登録します
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserDetail {...this.state} isCheck allGroupList={this.props.allGroupList} />
        </Modal.Body>
        <Modal.Footer>
          <Col sm={12} className="text-center">
            <Button
              variant="default"
              className="btn-96 margin-10 btn-default"
              onClick={this.props.onCancel}
            >
              キャンセル
            </Button>
            <Button
              variant="primary"
              className="btn-96 margin-10"
              onClick={this.props.onOK}
            >
              OK
            </Button>
          </Col>

        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({ ...{ user: state.user } });

export default connect(mapStateToProps)(UserCheckContainer);
